import { render, staticRenderFns } from "./CookieNotice.vue?vue&type=template&id=99885e9c"
import script from "./CookieNotice.vue?vue&type=script&lang=ts"
export * from "./CookieNotice.vue?vue&type=script&lang=ts"
import style0 from "./CookieNotice.vue?vue&type=style&index=0&id=99885e9c&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppBtn: require('/builds/project/wyffest/frontend/components/app/AppBtn.vue').default})
